
import * as vercelRuntime$HvlwcD0jd1 from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.0.0-rc.1/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$HvlwcD0jd1, defaults: {} }
}
        